import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ProvidersTableContainer = styled(Box)`
  div {
    flex-shrink: 1;
  }
`

export const CustomText = styled(Box)`
  align-items: center;
  gap: ${(props) => props.theme.spacing['2']};
`

export const Badge = styled.small<{ active: boolean }>`
  color: ${(props) =>
    props.active
      ? props.theme.colors.custom.purple
      : props.theme.colors.grey_4};
  font-weight: 500;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.colors.custom.purple
        : props.theme.colors.grey_4};
  background-color: ${(props) =>
    props.active
      ? props.theme.colors.custom.purple + 22
      : props.theme.colors.grey_5};
  padding: 0.2rem 0.5rem;
  border-radius: 50px;
`

export const CustomRowContainer = styled(Box)`
  background-color: ${({ theme }) => getThemeColor('warning', theme)}22;

  tr {
    width: 100%;
    align-items: center;
  }
`
